var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeeLess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2904 12.29L12.7004 9.7C12.3104 9.31 11.6804 9.31 11.2904 9.7L8.70044 12.29C8.07044 12.92 8.52044 14 9.41044 14L14.5904 14C15.4804 14 15.9204 12.92 15.2904 12.29Z",
    fill: "#6AC7BD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeeLess);
export default __webpack_public_path__ + "static/media/seeLess.e14e3bb02ee173fa52542922080fbd17.svg";
export { ForwardRef as ReactComponent };